var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationProvider", {
    ref: "provider",
    attrs: {
      mode: _vm.eagerIfDirty,
      vid: _vm.name,
      name: _vm.validateAs,
      rules: _vm.rules,
      bails: false,
      tag: "div"
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var classes = ref.classes
          var errors = ref.errors
          return [
            _c(
              "label",
              {
                staticClass:
                  "h-auto min-h-[250px] overflow-y-auto p-16 cursor-pointer hover:border-brown-400 border-dashed flex flex-col items-center justify-center px-16 font-bold text-20 bg-white border border-gray-200 placeholder-brown-400 focus:border-orange transition-colors",
                class: [
                  classes,
                  "w-full focus:outline-none flex items-center transition ease-in-out",
                  {
                    "!border-red":
                      errors[0] &&
                      ((classes.dirty && _vm.validAtleastOnce) ||
                        _vm.formValdiated)
                  }
                ]
              },
              [
                _c(
                  "input",
                  _vm._g(
                    {
                      ref: "fileEl",
                      attrs: {
                        id: "file",
                        type: "file",
                        name: _vm.name,
                        accept: _vm.acceptTypes,
                        multiple: true
                      }
                    },
                    Object.assign({}, _vm.$listeners, {
                      change: _vm.handleFileUpload,
                      focus: _vm.handleFocus,
                      blur: _vm.handleBlur
                    })
                  )
                ),
                _vm._v(" "),
                _vm.localFileObjects.length > 0
                  ? _vm._l(_vm.localFileObjects, function(fileObject, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "w-full flex flex-row gap-16 rounded-md p-8  cursor-default",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "h-50 w-50 border rounded-md border-brown-100 flex items-center justify-center flex-none p-8 bg-gray-200"
                            },
                            [
                              fileObject.preview
                                ? _c("img", {
                                    staticClass: "h-50 object-contain",
                                    attrs: { src: fileObject.preview, alt: "" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-bold text-14 text-gray-500 flex items-center whitespace-nowrap overflow-ellipsis overflow-hidden"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(fileObject.name) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex ml-auto items-center text-red cursor-pointer p-8 hover:bg-gray-200 w-[50px] justify-center rounded-md transition-colors",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.removeFile(fileObject, index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "far fa-trash" })]
                          )
                        ]
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex flex-col items-center justify-center",
                    class: { "mt-[25px]": _vm.localFileObjects.length > 0 }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-brown-400 text-20 font-bold mb-[20px]"
                      },
                      [_vm._v(_vm._s(_vm.placeholder))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-orange font-medium rounded-full text-white px-24 py-[7px] mb-8"
                      },
                      [_vm._v("selecteer bestand(en)")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-gray-400 text-14" }, [
                      _vm._v(_vm._s(_vm.acceptTypesLabels))
                    ])
                  ]
                )
              ],
              2
            ),
            _vm._v(" "),
            errors[0] &&
            ((classes.dirty && _vm.validAtleastOnce) || _vm.formValdiated)
              ? _c("span", { staticClass: "text-red mt-8 block text-12" }, [
                  _vm._v(_vm._s(errors[0]))
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }